"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorPicker = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
exports.ColorPicker = react_1.default.forwardRef(function (_a, ref) {
    var colors = _a.colors, value = _a.value, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.readonly, readonly = _c === void 0 ? false : _c, _d = _a.tabIndex, tabIndex = _d === void 0 ? 0 : _d, onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur;
    var handleItemClick = function (color) { return function () {
        if (!disabled && !readonly && color !== value && onChange) {
            onChange(color);
        }
    }; };
    var handleKeyDown = function (event) {
        var keyCode = event.nativeEvent.code;
        if (!onChange) {
            return;
        }
        if (keyCode === 'ArrowLeft') {
            for (var i = 1; i < colors.length; i = i + 1) {
                if (colors[i] === value) {
                    onChange(colors[i - 1]);
                    return;
                }
            }
            onChange(colors[colors.length - 1]); // in case we haven't found current value, or it was leftmost, pick the rightmost one as next
        }
        if (keyCode === 'ArrowRight') {
            for (var i = colors.length - 2; i >= 0; i = i - 1) {
                if (colors[i] === value) {
                    onChange(colors[i + 1]);
                    return;
                }
            }
            onChange(colors[0]); // in case we haven't found current value, or it was rightmost, pick the leftmost one as next
        }
    };
    return (react_1.default.createElement("div", { className: classnames_1.default('ColorPicker', {
            'ColorPicker--disabled': disabled,
        }), tabIndex: !disabled && !readonly ? tabIndex : undefined, onKeyDown: handleKeyDown, onFocus: onFocus, onBlur: onBlur, ref: ref }, colors.map(function (color, index) { return (react_1.default.createElement("div", { key: index, className: classnames_1.default('ColorPicker__Item', {
            'ColorPicker__Item--active': color === value,
        }), style: { backgroundColor: color }, onClick: handleItemClick(color) })); })));
});
//# sourceMappingURL=ColorPicker.js.map